import { SavedQueryMeta } from '@/views/SavedQueries/types';

export const getStepsInfo = (meta: SavedQueryMeta, saveDate: string) => {
  const steps =
    meta.isSql() && meta.noOfSteps() === 1
      ? 'SQL'
      : `${meta.noOfSteps()} step${meta.noOfSteps() === 1 ? '' : 's'}`;
  const savedBy = meta ? `${steps} saved by` : 'Saved by';

  return `${savedBy} ${meta.email}, ${saveDate}`;
};

export const getLastRefreshedInfo = (meta: SavedQueryMeta) => {
  const withResults = meta.noOfRows()
    ? `, ${meta.noOfRows()} results`
    : ', with error';

  return `${meta
    .lastRefreshed()
    ?.replace('ago', '')} since last refresh${withResults}`;
};
